import React from "react";
import PropTypes from "prop-types";
import { AdvertisingEmailWrapper } from "../../styled";

import { FormattedMessage } from "react-intl";

import { BodyCopy, ContentContainer, Step, StepOneContainer, Subtitle, Title, VerticalLine } from "../styled";

const NotHaveTsid = ({ email, appName }) => {
    return (
        <div>
            <Title>
                <FormattedMessage id="v-invitation-prelogin.not-have-tsid.title" />
            </Title>
            <ContentContainer>
                <StepOneContainer>
                    <Step>1</Step>
                    <VerticalLine />
                </StepOneContainer>
                <div>
                    <Subtitle>
                        <FormattedMessage id="v-invitation-prelogin.not-have-tsid.step1.subtitle" />
                    </Subtitle>
                    <BodyCopy>
                        <AdvertisingEmailWrapper>
                            <FormattedMessage
                                id="v-invitation-prelogin.not-have-tsid.step1.body-copy"
                                values={{
                                    b: chunks => <b>{chunks}</b>,
                                    email: email
                                }}
                            />
                        </AdvertisingEmailWrapper>
                    </BodyCopy>
                </div>
                <div>
                    <Step>2</Step>
                </div>
                <div>
                    <Subtitle>
                        <FormattedMessage
                            id="v-invitation-prelogin.not-have-tsid.step2.subtitle"
                            values={{
                                b: chunks => <b>{chunks}</b>
                            }}
                        />
                    </Subtitle>
                    <BodyCopy>
                        <FormattedMessage
                            id="v-invitation-prelogin.not-have-tsid.step2.body-copy"
                            values={{
                                appName: appName,
                                b: chunks => <b>{chunks}</b>
                            }}
                        />
                    </BodyCopy>
                </div>
            </ContentContainer>
        </div>
    );
};

NotHaveTsid.propTypes = {
    email: PropTypes.string.isRequired,
    appName: PropTypes.string.isRequired
};

export default NotHaveTsid;
